import { FC } from 'react'
import { Route, Link } from 'react-router-dom'

interface TabProps {
  to: string
  className?: string
  exact?: boolean
  replace?: boolean
  strict?: boolean
}

export const Tab: FC<TabProps> = ({ children, to, className, exact = false, replace = true, strict = true }) => {
  const escapedTo = to && to.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$&')
  const activeClass = 'active-tab'

  return (
    <>
      <Route
        path={escapedTo}
        exact={exact}
        strict={strict}
        children={({ location, match }) => {
          const isActive = location.pathname === match?.url
          const onClick = (e:any) => {
            if (isActive) {
              e.preventDefault()
            }
          }

          return (
            <Link
              to={to}
              replace={replace}
              className={isActive ? [className, activeClass].join(' ') : className}
              onClick={onClick}>
                { children }
            </Link>
          )
        }}
      />
    </>
  )
}

export default Tab
